export default "__VITE_ASSET__57756ed6__"